let Backbone = require("backbone");

let main = function () {
    var ReserveSucView = Backbone.View.extend({
        el: "#reserveSucModal",

        events: {
            'click .reserveSuc' : 'hideSucView'
        },
        show: function(){
            this.$el.modal("show");
        },
        hide: function() {
            this.$el.modal("hide");
        },
        hideSucView : function(){
            this.hide()
        }
    });

    return ReserveSucView;
};

let exportedValue = main();
module.exports = exportedValue;


// WEBPACK FOOTER //
// ./src/view/ReserveSucView.js